import { AdvancedMarker, APIProvider, Map } from '@vis.gl/react-google-maps';
import { GOOGLE_MAPS_API_KEY } from '../../../../../../../../../../constants/envs.ts';
import { tLocationContent } from './LocationContent.types.ts';

export default function LocationContent(props: tLocationContent) {
  const name = props.name?.trim();
  const address = props.address?.trim();

  // 23rem: the widest the map can be inside the bubble — MessageBubbleV2__Container
  // caps at max-w-sm (24rem) with px-2; anything wider overflows the bubble (BUG-758).
  return (
    <div
      data-testid="location-content"
      onClick={() => {
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${props.latitude},${props.longitude}`,
          '_blank',
        );
      }}
      className="flex flex-col w-[23rem] max-w-full"
    >
      {/* w-full: the map sizes itself from its parent, so a shrink-to-fit
          block would leave it zero wide. */}
      <div
        data-testid="location-map"
        className="flex flex-col h-40 w-full justify-center items-center"
      >
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
          <Map
            defaultCenter={{ lat: props.latitude, lng: props.longitude }}
            defaultZoom={15}
            gestureHandling={'greedy'}
            disableDefaultUI={true}
            mapId="9f58968e204c09e7 "
            controlled={false}
          >
            <AdvancedMarker
              position={{ lat: props.latitude, lng: props.longitude }}
            />
          </Map>
        </APIProvider>
      </div>
      {/* INT-1703: outside APIProvider so the place shows even when Maps never
          loads. ph-no-capture: the title attribute carries chat data, which
          replays record unless the element blocks it. The address dims the
          bubble's own text color, like BubbleMeta: a theme token would turn
          near-white in dark mode on the always-light incoming bubble. */}
      {(name || address) && (
        <div
          data-testid="location-place"
          className="flex flex-col pt-1 min-w-0"
        >
          {name && (
            <span
              data-testid="location-name"
              title={name}
              className="ph-no-capture truncate text-sm font-medium"
            >
              {name}
            </span>
          )}
          {address && (
            <span
              data-testid="location-address"
              title={address}
              className="ph-no-capture line-clamp-2 break-words text-xs text-[color-mix(in_srgb,currentColor_65%,transparent)]"
            >
              {address}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
